<template>
  <div class="find">
    <div class="wrap fd-wrap">
    

      <!--content start-->
      <activity :find="find" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="200"
                infinite-scroll-throttle-delay="1000"></activity>

      <!--content end-->
      <!-- nav-bottom -->
      <div class="nav-bottom">
        <router-link class="icon-title" to="/home">
          <i class="icon-index"></i>
           推荐
        </router-link>
        <!--router-link class="icon-title" to="/discovery">
          <i class="icon-find"></i>
          发现
        </router-link-->
        <router-link class="icon-title" to="/MyMessage">
          <i class="icon-mine"></i>
          我的
        </router-link>
      </div>

    </div>

    <div class="fd-sh-wrap" style="display: none">
      <!--header start-->
      <div class="header fd-search">
        <div class="fd-input-box">
          <!--、央视频道、栏目名称-->
          <input v-on:input="myupfun" class="fd-input-input" v-model="searchText" type="text" placeholder="活动名称"/>
          <i class="icon-search" @click="search"></i>
        </div>
        <!--    <span v-if="cancels" class="cancel" @click="search">搜索</span>-->
        <span class="cancel" @click="cancel">取消</span>

      </div>
      <!--header end-->

    </div>

    <!--遮罩-->
    <div class="overplay" style="display:none"></div>

    <!-- 返回顶部按钮 -->
    <div class="back-top" @click="fn" style="display:none">
      返回顶部
    </div>
  </div>
</template>

<script>
  import activity from './template/activity.vue'

  export default {
    data() {
      return {
        lenNew: 0,
        num: false,
        scrill: false,
        busy: false,
        channel: '',
        nav_on: 0,
        searchText: '',
        len: 10,
        // find: {
        //   page: 1,
        //   pagesize: 10,
        //   type: 'indexhotactivity'
        // },
         find: {
          page: 1,
          pagesize: 10,
            progress: 'on',
        },
        
        total: 0,
        Page: 1, //页码
        pagesize: 10, //每页的歌个数
        searchName: [],
        findSearch: null,
        initUtil: {
          bodyEl: document.body,
          topNum: 0,
          stopBodyScroll: function (isFixed) {
            var _this = this;
            if (isFixed) {
              _this.topNum = window.scrollY;
              _this.bodyEl.style.position = 'fixed';
              _this.bodyEl.style.overflow = 'hidden';
              _this.bodyEl.style.top = -_this.topNum + 'px';
            } else {
              _this.bodyEl.style.position = '';
              _this.bodyEl.style.top = '';
              _this.bodyEl.style.overflow = '';
              window.scrollTo(0, _this.topNum) // 回到原先的top;
            }
          }
        },
        cancels: false,
        pageNmae: 1
      }
    },
    components: {   //渲染页面
      activity: activity
    },
    methods: {
      //操作按钮事件
      route(id) {
        var url = '';
        var hrefHTML = this.hrefHTML(0, id)
        if (hrefHTML) {
          window.location.href = hrefHTML
        } else {
          window.location.href = API.UrlName + 'detail/' + id
        }
      },
      //返回顶部
      fn() {
        $('html,body').stop().animate({scrollTop: '0px'}, 500);
      },
      //取消
      cancel() {
        $('.cancel').parents('.fd-sh-wrap').hide();
        this.initUtil.stopBodyScroll(false);
      },
      //tab切换
      Table(ind) {
        //console.log(ind)
        var that = this;
        that.nav_on = 2;
        that.initUtil.stopBodyScroll(false);
        that.len = 10;
        that.Page = 1;
        that.num = false;
        that.lenNew = 0;
        ind =2;
        if (ind == 0) {
          that.busy =true;
        }else{
          that.busy =false;
        }
        
        if (ind == 0) {
          //推荐
          that.Page = 1;
          that.find = {
            type: 'indexhotactivity',
            page: that.Page,
            pagesize: that.pagesize
          };

        } else if (ind == 1) {
          //频道活动
          that.find = {
            channel_id: $('.icon-red').attr('data-id'),
            page: that.Page,
            pagesize: that.pagesize
          };
          if (!$('.id-nav-list').hasClass('show-none')) { // 导航展开收起效果
            $('.id-nav-list').addClass('nav-on show-none').siblings().removeClass('nav-on');
            $('.overplay').hide();
            $('.nav-list').slideUp(500);
          } else {
            $('.id-nav-list').removeClass('show-none');
            $('.overplay').show();
            $('.nav-list').slideDown(500);
          }
        } else if (ind == 2) {
          //进行中
          that.find = {
            progress: 'on',
            page: 1,
            pagesize: that.pagesize
          };
        } else if (ind == 3) {
          //已结束
          that.find = {
            progress: 'off',
            page: 1,
            pagesize: that.pagesize
          };
        }
        setTimeout(function () {
          that.num = true;
        }, 500)
      },
      channelClick(ind) {
        var that = this;
        var navList = $('.channel').eq(ind).attr('data-name');
        $('.id-nav-list').html(navList.slice(0, 4));
        $('.id-nav-list').addClass('show-none');
        $('.overplay').hide();
        $('.nav-list').slideUp(500);
        $('.channel').eq(ind).addClass('icon-red').parent().siblings().children().removeClass('icon-red')
        that.Page = 1;
        that.find = {
          channel_id: $('.icon-red').attr('data-id'),
          page: that.Page,
          pagesize: that.pagesize
        };
      },
      search() { //搜索
        that = this;
        that.len = 10;
        var that = this;
        that.findSearch = {
          title: that.searchText,
          page: that.Page,
          pagesize: that.pagesize,
          version: 2
        };
        that.searchName = [];
        // console.log(find);
      },
      myupfun() {
        that = this;
        if ($('.fd-input-input').val()) {
          that.cancels = true
        } else {
          that.cancels = false
        }
        that.Page = 1;
        that.len = 10;
        var that = this;
        that.findSearch = {
          title: that.searchText,
          page: that.Page,
          pagesize: that.pagesize,
          version: 2
        };
        that.pageNmae = 1
        that.searchName = []
      },
      //显示搜索
      searchShow() {
        this.scrill = false;
        this.pageNmae = 1
        $('.fd-input-input').val('')
        $('.fd-sh-wrap').show();
        this.initUtil.stopBodyScroll(true);
      },
      //加载更更多
      loadMore() {
        var that = this;
        //  if (that.num) {
          var page = ++that.Page;
          that.find.progress = 'on'
          if (that.find.type == 'indexhotactivity') { //热门
            that.find = {
              type: 'indexhotactivity',
              page: page,
              pagesize: that.pagesize
            };
          } else if (that.find.channel_id != undefined) {  //频道列表
            that.find = {
              channel_id: $('.icon-red').attr('data-id'),
              page: page,
              pagesize: that.pagesize
            };
          } else if (that.find.progress == 'on') {  //进行中
            that.find = {
              progress: 'on',
              page: page,
              pagesize: that.pagesize
            };
          } else if (that.find.progress == 'off') { //已结束
            that.find = {
              progress: 'off',
              page: page,
              pagesize: that.pagesize
            };
          } else { //搜索
            that.findSearch = {
              title: that.searchText,
              page: page,
              pagesize: that.pagesize,
              version: 2
            };
          }
        // }
        var len = $('.fd-content').find('li').length
        if(that.lenNew > len){
          that.busy =true;
        }
        that.lenNew = that.lenNew/1 + 10
        //  ++that.Page
      },
      contentMore() {
        this.pageNmae = ++this.pageNmae
        this.findSearch = {
          title: this.searchText,
          page: this.pageNmae,
          pagesize: this.pagesize,
          version: 2
        };
      }
    },
    beforeRouteLeave(to, from, next) {
      // 设置下一个路由的 meta
      to.meta.keepAlive = false;
      next();
    },
    created: function () {
      var that = this;
      //央视频道
      // this.$http.get(API.GetChannelList)
      //   .then(function (res) {
      //     if (res.code == 0) {
      //       that.channel = res.data;
      //       //console.log(res.data)
      //     }
      //   });
      that.Page = 1;
      // that.find = {
      //   type: 'indexhotactivity',
      //   page: 1,
      //   pagesize: that.pagesize
      // };
       that.find = {
              progress: 'on',
              page: 1,
              pagesize: that.pagesize
            };
      //  this.Table(2);
        // setTimeout(function () {
        //   that.num = true;
        // }, 500)
      // Table(2)
      //搜索选项
      // that.$watch('findSearch', function () {
      //   this.$http.get(API.GetActivities, {params: that.findSearch})
      //     .then(function (res) {
      //       if (res.code == 0) {
      //         for (var i = 0; i < res.data.length; i++) {
      //           that.searchName.push(res.data[i])
      //         }
      //         that.total = res.total
      //         if (that.searchName.length == res.total) {
      //           that.scrill = false
      //         } else {
      //           that.scrill = true
      //         }
      //         //console.log(res.data)
      //         that.$nextTick(function () {
      //           if (res.total > 0) {
      //             let metas = $('head').children('meta');
      //             var img = '';
      //             console.log(that.searchName[0])
      //             if (that.searchName && that.searchName[0].playbill && that.searchName[0].playbill.playbill_h5) {
      //               img = that.searchName[0].playbill.playbill_h5
      //             }
      //             var dataName = {
      //               title: document.title,  //分享标题
      //               desc: that.removeTAG(metas[1].content, 110),//分享简介(内容)
      //               imgAddress: img,//分享图片地址
      //               Retain: '',//保留
      //               url: API.UrlName + 'find' //点击分享结果跳转的地址('' 默认情况为分享页面当前地址)
      //             };
      //             that.weixinShare(dataName)
      //           }
      //           //图片尺寸控制 16:9
      //           var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
      //           $('.pic-box').find('img').css({height: picHimg, visibility: 'visible'});
      //         }, 500)
      //       }
      //     });
      // })
    }
    ,
    mounted: function () {
      //操作DOM
      // var that = this;
      // var scrill = false;
      //  setTimeout(function(){
      // _vjTrack('')
      //},500)
      // $(window).scroll(function () {
      //   if ($(window).scrollTop() > 1000) {
      //     $('.back-top').show();
      //   } else {
      //     $('.back-top').hide();
      //   }
      // });

      // $(function () {
      //   // this.find = {
      //   //   type: 'indexhotactivity',
      //   //   page: 1,
      //   //   pagesize: that.pagesize
      //   // };

      //     // that.find = {
      //     //     progress: 'on',
      //     //     page: 1,
      //     //     pagesize: that.pagesize
      //     //   };
      //   setTimeout(function () {
      //     //图片比例
      //     that.PictureRatio();
      //     // that.num = true;
      //   }, 500)
      // })

    }
  }
</script>

<style>
  .nav-bottom {
    box-shadow: 0 1px 8px #888888;
  }
</style>



// WEBPACK FOOTER //
// src/components/find.vue